import { lazy } from 'react';
import { authRoles } from 'app/auth';

const DailyReportAppConfig = {
	settings: {
		layout: {}
	},
	auth: authRoles.admin,
	routes: [
		{
			path: '/apps/settings/daily-report',
			component: lazy(() => import('./list/DailyReport'))
		}
	]
};

export default DailyReportAppConfig;
